module.exports = __webpack_public_path__ + "img/stairs-1.c0834f1f.png";